import React from 'react'
import { Link } from 'react-router-dom';


const TestScreen = () => {

  return <div>
   <Link to='/dashboard'>Dashboard</Link>
  </div>
};

export default TestScreen;